<template>
  <div
    :class="{
      'text-xs text-gray-500': discountPrice,
      'text-base': !discountPrice,
    }"
  >
    <template v-if="discountPrice">Fornyes til </template>
    kr. {{ formatPrice(recurringPrice) }}/år
  </div>
  <div v-if="discountPrice" class="text-base">
    kr. {{ formatPrice(discountPrice) }} første år
  </div>
</template>

<script lang="ts" setup>
import { useTldCatalogStore } from "../../stores/catalog/tld-catalog";
import { formatPrice } from "../../helpers/priceHelpers";

const props = defineProps<{
  tld: string;
}>();

const tldCatalog = useTldCatalogStore();

const tld = computed(() => tldCatalog.getByTld(props.tld));

const recurringPrice = computed(() => {
  return tld.value?.priceRecurring?.unitPriceWithDiscount ?? "?";
});

const discountPrice = computed(() => {
  if (typeof recurringPrice.value !== "number") {
    return null;
  }

  const startupPrice = tld.value?.priceStartup?.unitPriceWithDiscount;

  if (!startupPrice) {
    return null;
  }

  if (startupPrice >= recurringPrice.value) {
    return null;
  }

  return tld.value?.priceStartup?.unitPriceWithDiscount;
});
</script>

<style></style>
